import React from 'react';
import { CoinsIcon, TrendingUpIcon, GiftIcon, AwardIcon, StarIcon } from 'lucide-react';
const leaderboard = [{
  rank: 1,
  name: 'Sarah Kim',
  role: 'Sr. Loan Originator',
  coinsMonth: 47,
  coinsAllTime: 312,
  streak: '🔥 6 months',
  avatar: 'SK',
  color: '#2B8DC4'
}, {
  rank: 2,
  name: 'Marcus Thompson',
  role: 'Lead Processor',
  coinsMonth: 38,
  coinsAllTime: 287,
  streak: '🔥 4 months',
  avatar: 'MT',
  color: '#1A2B3C'
}, {
  rank: 3,
  name: 'Priya Rajan',
  role: 'Loan Originator',
  coinsMonth: 35,
  coinsAllTime: 198,
  streak: '🔥 3 months',
  avatar: 'PR',
  color: '#1E6FA0'
}, {
  rank: 4,
  name: 'Carlos Mendez',
  role: 'Branch Manager',
  coinsMonth: 32,
  coinsAllTime: 245,
  streak: '—',
  avatar: 'CM',
  color: '#2B8DC4'
}, {
  rank: 5,
  name: 'Derek Liu',
  role: 'Processor',
  coinsMonth: 28,
  coinsAllTime: 176,
  streak: '🔥 2 months',
  avatar: 'DL',
  color: '#1A2B3C'
}, {
  rank: 6,
  name: 'Alex Chen',
  role: 'Loan Originator',
  coinsMonth: 24,
  coinsAllTime: 89,
  streak: '—',
  avatar: 'AC',
  color: '#1E6FA0'
}, {
  rank: 7,
  name: 'Lisa Martinez',
  role: 'Training Manager',
  coinsMonth: 18,
  coinsAllTime: 156,
  streak: '—',
  avatar: 'LM',
  color: '#2B8DC4'
}, {
  rank: 8,
  name: 'James Park',
  role: 'Sr. Underwriter',
  coinsMonth: 15,
  coinsAllTime: 134,
  streak: '—',
  avatar: 'JP',
  color: '#1A2B3C'
}];
const rankLabels = ['🥇', '🥈', '🥉', '4', '5', '6', '7', '8'];
export function SwiftCoins() {
  return <div style={{
    maxWidth: 1280,
    margin: '0 auto'
  }} data-id="element-731">
      {/* Hero Banner */}
      <div style={{
      borderRadius: 16,
      padding: '32px 40px',
      marginBottom: 24,
      position: 'relative',
      overflow: 'hidden',
      background: 'linear-gradient(118deg, #0D1B2A 0%, #1E6FA0 45%, #0D1B2A 100%)',
      minHeight: 160
    }} data-id="element-732">
        <div style={{
        position: 'absolute',
        inset: 0,
        backgroundImage: 'repeating-linear-gradient(-55deg, transparent, transparent 18px, rgba(255,255,255,0.025) 18px, rgba(255,255,255,0.025) 36px)',
        pointerEvents: 'none'
      }} data-id="element-733" />
        <div style={{
        position: 'absolute',
        top: 0,
        right: 0,
        width: '40%',
        height: '100%',
        background: 'linear-gradient(118deg, transparent 0%, rgba(43,141,196,0.2) 100%)',
        clipPath: 'polygon(30% 0, 100% 0, 100% 100%, 0% 100%)',
        pointerEvents: 'none'
      }} data-id="element-734" />
        <div style={{
        position: 'absolute',
        right: 40,
        top: '50%',
        transform: 'translateY(-50%)',
        opacity: 0.1,
        pointerEvents: 'none'
      }} data-id="element-735">
          <CoinsIcon size={160} color="#D4A017" data-id="element-736" />
        </div>
        <div style={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        height: 4,
        background: 'linear-gradient(90deg, #D4A017 0%, #F3E5AB 60%, transparent 100%)'
      }} data-id="element-737" />
        <div style={{
        position: 'relative',
        zIndex: 1
      }} data-id="element-738">
          <div style={{
          fontSize: 12,
          color: 'rgba(255,255,255,0.5)',
          fontWeight: 600,
          letterSpacing: '0.1em',
          textTransform: 'uppercase',
          marginBottom: 6
        }} data-id="element-739">
            Rewards Program
          </div>
          <h2 style={{
          fontSize: 32,
          fontWeight: 900,
          color: '#FFFFFF',
          margin: '0 0 6px',
          fontStyle: 'italic',
          letterSpacing: '-0.04em',
          lineHeight: 1
        }} data-id="element-740">
            Swift Coins 🪙
          </h2>
          <p style={{
          color: 'rgba(255,255,255,0.6)',
          fontSize: 14,
          margin: '0 0 16px',
          fontWeight: 500
        }} data-id="element-741">
            Earn coins for production, teamwork, and growth.
          </p>
          <div style={{
          display: 'flex',
          gap: 10,
          flexWrap: 'wrap'
        }} data-id="element-742">
            <span style={{
            padding: '5px 14px',
            borderRadius: 6,
            fontSize: 12,
            fontWeight: 800,
            background: '#D4A017',
            color: 'white',
            fontStyle: 'italic'
          }} data-id="element-743">
              247 Coins Distributed This Month
            </span>
          </div>
        </div>
      </div>

      <div style={{
      display: 'grid',
      gridTemplateColumns: '2fr 1fr',
      gap: 20
    }} data-id="element-744">
        {/* Leaderboard */}
        <div style={{
        background: '#FFFFFF',
        borderRadius: 12,
        padding: '24px',
        border: '1px solid #E4EAF6',
        borderTopWidth: 3,
        borderTopColor: '#D4A017',
        boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
      }} data-id="element-745">
          <h3 style={{
          fontSize: 16,
          fontWeight: 900,
          color: '#1A2B3C',
          margin: '0 0 20px',
          fontStyle: 'italic',
          letterSpacing: '-0.02em',
          display: 'flex',
          alignItems: 'center',
          gap: 8
        }} data-id="element-746">
            <TrendingUpIcon size={18} color="#D4A017" data-id="element-747" /> Monthly Leaderboard
          </h3>
          <div style={{
          overflowX: 'auto'
        }} data-id="element-748">
            <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            textAlign: 'left'
          }} data-id="element-749">
              <thead data-id="element-750">
                <tr style={{
                borderBottom: '2px solid #E4EAF6'
              }} data-id="element-751">
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }} data-id="element-752">
                    Rank
                  </th>
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em'
                }} data-id="element-753">
                    Name
                  </th>
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  textAlign: 'right'
                }} data-id="element-754">
                    Coins This Month
                  </th>
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  textAlign: 'right'
                }} data-id="element-755">
                    All-Time
                  </th>
                  <th style={{
                  padding: '12px 8px',
                  fontSize: 11,
                  fontWeight: 800,
                  color: '#A0AECB',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  textAlign: 'right'
                }} data-id="element-756">
                    Streak
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-757">
                {leaderboard.map((p, i) => <tr key={p.rank} style={{
                borderBottom: '1px solid #E4EAF6',
                background: i === 0 ? '#FFFBEB' : 'transparent'
              }} data-id="element-758">
                    <td style={{
                  padding: '12px 8px',
                  fontSize: 18,
                  width: 40,
                  textAlign: 'center'
                }} data-id="element-759">
                      {rankLabels[i]}
                    </td>
                    <td style={{
                  padding: '12px 8px'
                }} data-id="element-760">
                      <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 10
                  }} data-id="element-761">
                        <div style={{
                      width: 32,
                      height: 32,
                      borderRadius: 8,
                      background: p.color,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontSize: 11,
                      fontWeight: 900,
                      color: 'white',
                      transform: 'skewX(-4deg)'
                    }} data-id="element-762">
                          {p.avatar}
                        </div>
                        <div data-id="element-763">
                          <div style={{
                        fontSize: 13,
                        fontWeight: 800,
                        color: '#1A2B3C'
                      }} data-id="element-764">
                            {p.name}
                          </div>
                          <div style={{
                        fontSize: 11,
                        color: '#5A6A8A'
                      }} data-id="element-765">
                            {p.role}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td style={{
                  padding: '12px 8px',
                  fontSize: 14,
                  fontWeight: 800,
                  color: '#D4A017',
                  textAlign: 'right'
                }} data-id="element-766">
                      {p.coinsMonth} 🪙
                    </td>
                    <td style={{
                  padding: '12px 8px',
                  fontSize: 13,
                  fontWeight: 600,
                  color: '#5A6A8A',
                  textAlign: 'right'
                }} data-id="element-767">
                      {p.coinsAllTime}
                    </td>
                    <td style={{
                  padding: '12px 8px',
                  fontSize: 12,
                  color: '#1A2B3C',
                  textAlign: 'right',
                  fontWeight: 600
                }} data-id="element-768">
                      {p.streak}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <div style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 20
      }} data-id="element-769">
          {/* How to Earn */}
          <div style={{
          background: '#FFFFFF',
          borderRadius: 12,
          padding: '24px',
          border: '1px solid #E4EAF6',
          borderTopWidth: 3,
          borderTopColor: '#2B8DC4',
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
        }} data-id="element-770">
            <h3 style={{
            fontSize: 16,
            fontWeight: 900,
            color: '#1A2B3C',
            margin: '0 0 16px',
            fontStyle: 'italic',
            letterSpacing: '-0.02em',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }} data-id="element-771">
              <StarIcon size={18} color="#2B8DC4" data-id="element-772" /> How Coins Are Earned
            </h3>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12
          }} data-id="element-773">
              <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: 8,
              borderBottom: '1px solid #E4EAF6'
            }} data-id="element-774">
                <span style={{
                fontSize: 13,
                color: '#1A2B3C',
                fontWeight: 600
              }} data-id="element-775">
                  Loan Closed
                </span>
                <span style={{
                fontSize: 13,
                fontWeight: 800,
                color: '#D4A017'
              }} data-id="element-776">
                  +5 🪙
                </span>
              </div>
              <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: 8,
              borderBottom: '1px solid #E4EAF6'
            }} data-id="element-777">
                <span style={{
                fontSize: 13,
                color: '#1A2B3C',
                fontWeight: 600
              }} data-id="element-778">
                  Referral Generated
                </span>
                <span style={{
                fontSize: 13,
                fontWeight: 800,
                color: '#D4A017'
              }} data-id="element-779">
                  +3 🪙
                </span>
              </div>
              <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: 8,
              borderBottom: '1px solid #E4EAF6'
            }} data-id="element-780">
                <span style={{
                fontSize: 13,
                color: '#1A2B3C',
                fontWeight: 600
              }} data-id="element-781">
                  Training Completed
                </span>
                <span style={{
                fontSize: 13,
                fontWeight: 800,
                color: '#D4A017'
              }} data-id="element-782">
                  +2 🪙
                </span>
              </div>
              <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              paddingBottom: 8,
              borderBottom: '1px solid #E4EAF6'
            }} data-id="element-783">
                <span style={{
                fontSize: 13,
                color: '#1A2B3C',
                fontWeight: 600
              }} data-id="element-784">
                  Team Shout-out
                </span>
                <span style={{
                fontSize: 13,
                fontWeight: 800,
                color: '#D4A017'
              }} data-id="element-785">
                  +1 🪙
                </span>
              </div>
              <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center'
            }} data-id="element-786">
                <span style={{
                fontSize: 13,
                color: '#1A2B3C',
                fontWeight: 600
              }} data-id="element-787">
                  Monthly Top Performer
                </span>
                <span style={{
                fontSize: 13,
                fontWeight: 800,
                color: '#D4A017'
              }} data-id="element-788">
                  +10 🪙
                </span>
              </div>
            </div>
          </div>

          {/* Prizes */}
          <div style={{
          background: '#FFFFFF',
          borderRadius: 12,
          padding: '24px',
          border: '1px solid #E4EAF6',
          borderTopWidth: 3,
          borderTopColor: '#1A2B3C',
          boxShadow: '0 2px 8px rgba(13,27,42,0.06)'
        }} data-id="element-789">
            <h3 style={{
            fontSize: 16,
            fontWeight: 900,
            color: '#1A2B3C',
            margin: '0 0 16px',
            fontStyle: 'italic',
            letterSpacing: '-0.02em',
            display: 'flex',
            alignItems: 'center',
            gap: 8
          }} data-id="element-790">
              <GiftIcon size={18} color="#1A2B3C" data-id="element-791" /> Monthly Prizes
            </h3>
            <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 12
          }} data-id="element-792">
              <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '12px',
              borderRadius: 8,
              background: '#F4F8FC',
              border: '1px solid #E4EAF6'
            }} data-id="element-793">
                <div style={{
                fontSize: 16,
                fontWeight: 900,
                color: '#D4A017',
                width: 40
              }} data-id="element-794">
                  50+
                </div>
                <div data-id="element-795">
                  <div style={{
                  fontSize: 13,
                  fontWeight: 800,
                  color: '#1A2B3C'
                }} data-id="element-796">
                    $100 Gift Card
                  </div>
                  <div style={{
                  fontSize: 11,
                  color: '#5A6A8A'
                }} data-id="element-797">
                    Amazon, Starbucks, or Target
                  </div>
                </div>
              </div>
              <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '12px',
              borderRadius: 8,
              background: '#F4F8FC',
              border: '1px solid #E4EAF6'
            }} data-id="element-798">
                <div style={{
                fontSize: 16,
                fontWeight: 900,
                color: '#D4A017',
                width: 40
              }} data-id="element-799">
                  100+
                </div>
                <div data-id="element-800">
                  <div style={{
                  fontSize: 13,
                  fontWeight: 800,
                  color: '#1A2B3C'
                }} data-id="element-801">
                    Extra PTO Day
                  </div>
                  <div style={{
                  fontSize: 11,
                  color: '#5A6A8A'
                }} data-id="element-802">
                    Added to your balance automatically
                  </div>
                </div>
              </div>
              <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: 12,
              padding: '12px',
              borderRadius: 8,
              background: '#F4F8FC',
              border: '1px solid #E4EAF6'
            }} data-id="element-803">
                <div style={{
                fontSize: 16,
                fontWeight: 900,
                color: '#D4A017',
                width: 40
              }} data-id="element-804">
                  200+
                </div>
                <div data-id="element-805">
                  <div style={{
                  fontSize: 13,
                  fontWeight: 800,
                  color: '#1A2B3C'
                }} data-id="element-806">
                    President's Club Dinner
                  </div>
                  <div style={{
                  fontSize: 11,
                  color: '#5A6A8A'
                }} data-id="element-807">
                    Exclusive dinner with executive team
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
}